var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTag = function SvgTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#374255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m18.983 11.794-7.402 7.624c-.142.145-.44.096-.653-.121l-4.99-5.014c-.213-.218-.273-.508-.118-.665l7.4-7.624c.143-.145 4.99.69 4.99.69s.927 4.965.773 5.11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#374255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m17.569 6.573-.357-1.969a.62.62 0 0 0-.522-.507l-4.241-.592a.62.62 0 0 0-.511.18l-6.76 6.96a.62.62 0 0 0 0 .87l1.343 1.365M15.264 10.876c.65 0 1.176-.536 1.176-1.196 0-.661-.527-1.197-1.176-1.197-.65 0-1.176.536-1.176 1.197 0 .66.527 1.196 1.176 1.196"
  })));
};
export default SvgTag;